import React from "react";
import TopicRightPane from "./TopicRightPane";
import topicCrossIcon from "../../images/topicCrossIcon.png";
import topicMenuIcon from "../../images/topicMenuIcon.png";

class TopicMiddlePanes extends React.Component {

    state={
        activeTopic:null,
        activeSubTopic:null,
    }

  expandTopicMenu = () => {
    document.querySelector(".topics").style.display = "block";
    document.querySelector(".mobile-topic-menu-icon").style.display = "none";
    document.querySelector(".topic-menu-header").style.display = "flex";
    document.querySelectorAll(".topic-item-heading").forEach((heading) => {
      heading.classList.remove("pointer-none");
    });
  };
  contractTopicMenu = () => {
    document.querySelector(".topics").style.display = "flex";
    document.querySelector(".mobile-topic-menu-icon").style.display = "flex";
    document.querySelector(".topic-menu-header").style.display = "none";
    document
      .querySelectorAll(".topic-items-container")
      .forEach((topicContainer) => {
        topicContainer.classList.remove("open");
        topicContainer.classList.add("close");
      });
    document.querySelectorAll(".topic-item-heading").forEach((heading) => {
      heading.classList.add("pointer-none");
    });
  };
  handleTopic = (e, src) => {
    this.setState({
        activeTopic:src,
      })
    document
      .querySelectorAll(".topic-items-container")
      .forEach((topicContainer) => {
        if (topicContainer.id === e.target.innerText) {
          if (!topicContainer.hasChildNodes()) {
            this.scrollToContent(src);
          }
          if (topicContainer.classList.contains("open")) {
            topicContainer.classList.remove("open");
            topicContainer.classList.add("close");
          } else {
            topicContainer.classList.remove("close");
            topicContainer.classList.add("open");
          }
        } else {
          topicContainer.classList.remove("open");
          topicContainer.classList.add("close");
        }
      });
  };
  scrollToContent = (src) => {
      
      this.setState({
        activeSubTopic:src,
      })
    let contentElement = document.getElementById(src.split("#")[1]);
    let scrollHt = contentElement.offsetTop - 110;
    if (window.screen.width < 769) {
      this.contractTopicMenu();
      scrollHt = contentElement.offsetTop - 150;
    }
    if (contentElement !== null) {
      window.scrollTo({ top: scrollHt, behavior: "smooth" });
    }
  };

  render() {
    return (
      <div className="content">
        {this.props.leftPane.length > 0 ? (
          <div className="topics">
            <div className="topic-menu-header">
              <p>Jump To</p>
              <img
                src={topicCrossIcon}
                onClick={this.contractTopicMenu}
                alt=""
              />
            </div>
            <div
              className="topic-item mobile-topic-menu-icon"
              onClick={this.expandTopicMenu}
            >
              <img src={topicMenuIcon} alt="" />
            </div>
            {this.props.leftPane.map((item) => {
              return (
                <div className="topic-item" key={item.id}>
                  <p
                    className={`topic-item-heading pointer-none ${this.state.activeTopic===item.src?"active":null}`}
                    onClick={(e) => this.handleTopic(e, item.src)}
                  >
                    {item.title}
                  </p>
                  <div className="topic-items-container close" id={item.title}>
                    {item.subTopicDetailList.map((l2) => {
                      return (
                        <p
                          className={`topic-items ${this.state.activeSubTopic===l2.src?"active":null}`}
                          key={l2.id}
                          onClick={() => {
                            this.scrollToContent(l2.src);
                          }}
                        >
                          {l2.title}
                        </p>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          ""
        )}
        <div className="content-hybris">
          <p
            dangerouslySetInnerHTML={{
              __html: this.props.content !== null ? this.props.content : "",
            }}
          ></p>
        </div>
        <TopicRightPane rightPane={this.props.rightPane} />
      </div>
    );
  }
}

export default TopicMiddlePanes;
